import { PhoneHelper } from 'src/utils/phoneHelper';
import { supportPhone, supportEmail } from 'src/utils/capabilities';

const { t } = window.translation;

export const headerActionsList = {
  dashboard: {
    label: t('subAgentHeader.dashboard'),
    icon: 'dashboard',
  },
  accounts: {
    label: t('subAgentHeader.accounts'),
    icon: 'accounts',
  },
  advice: {
    label: t('subAgentHeader.advice'),
    icon: 'advice',
  },
  appetite_guide: {
    label: t('subAgentHeader.appetiteGuide'),
    icon: 'guide',
  },
  my_agency: {
    label: t('subAgentHeader.myAgency'),
    icon: 'agency',
  },
};

const formattedHelpPhoneData = PhoneHelper.getFormattedPhone(supportPhone);

export const getDropdownActionsList = logoutUrl => {
  return [
    {
      label: `${t('subAgentHeader.contactUs')} - ${supportEmail}`,
      mobileLabel: t('subAgentHeader.contactUs'),
      icon: 'contact',
      link: `mailto:${supportEmail}`,
      external: true,
    },
    {
      label: formattedHelpPhoneData.nationalNumber
        ? `${t('subAgentHeader.callUs')} - ${
            formattedHelpPhoneData.nationalNumber
          }`
        : t('subAgentHeader.callUs'),
      mobileLabel: formattedHelpPhoneData.nationalNumber,
      icon: 'phone-outlined',
      link: formattedHelpPhoneData.URINumber,
      external: true,
    },
    {
      label: t('subAgentHeader.logOut'),
      icon: 'mywallet-logout',
      link: logoutUrl,
      logout: true,
      external: true,
    },
  ];
};
